<template>
  <button v-bind="$attrs" @click="fileInput.click()">
    <slot>Apply with CV</slot>
  </button>
  <input ref="fileInput" :accept="accept" class="d-none" type="file" @change="uploadFile">
</template>

<script setup>

import {ref} from "vue";

const accept = '.pdf,.odt,.docx,.doc,.jpg,.jpeg,.png,.gif,.rtf';

const props = defineProps({
  postUrl: String
})

const fileInput = ref({});

const emit = defineEmits(['loadedCVData', 'submittedCVData', 'error']);

const uploadFile = () => {
  // get file from input
  const file = fileInput.value.files[0];


  emit('submittedCVData');

  // create form data with file
  let data = new FormData();
  data.append('cv', file)

  axios.post('/ajax/' + props.postUrl, data, {
    headers: {"Content-Type": "multipart/form-data"}
  })
      .then(response => {
        emit('loadedCVData', response.data, file);
      })
      .catch(error => {
        emit('error', 'Es trat ein unerwarteter Fehler auf, bitte versuchen sie es Später erneut.');
      });
}

</script>

<style scoped>

</style>